<ng-container *ngIf="!isDto && !showAsHeading">
  <label *ngIf="labelTranslated" for="{{inputId}}" l10nTranslate>
    <span [class.with-colon]="colon">{{label}}</span>
    <span class="required" *ngIf="required" l10nTranslate>Required</span>
  </label>
  <label *ngIf="!labelParameters && !labelTranslated" for="{{inputId}}">
    <span [class.with-colon]="colon">{{label}}</span>
    <span class="required" *ngIf="required" l10nTranslate>Required</span>
  </label>
  <label *ngIf="labelParameters && !labelTranslated" for="{{inputId}}">
    <span [class.with-colon]="colon">{{label | translate:lang:labelParameters}}</span>
    <span class="required" *ngIf="required" l10nTranslate>Required</span>
  </label>
</ng-container>
<ng-container *ngIf="!isDto && showAsHeading">
  <h3 *ngIf="labelTranslated" style="text-align:center">
    <span [class.with-colon]="colon" l10nTranslate>{{label}}</span>
    <span class="required" *ngIf="required" l10nTranslate>Required</span>
  </h3>
  <h3 *ngIf="!labelTranslated" style="text-align:center">
    <span [class.with-colon]="colon">{{label}}</span>
    <span class="required" *ngIf="required" l10nTranslate>Required</span>
  </h3>
</ng-container>
<ng-container *ngIf="isDto">
  <label for="{{inputId}}">
    <samplicity-display-translation [values]="label"></samplicity-display-translation>
    <span class="required" *ngIf="required" l10nTranslate>Required</span>
  </label>
</ng-container>
